export const GENERAL_ERROR = 'GENERAL_ERROR';
export const CREATE_ORDER = 'CREATE_ORDER';
export const GET_ORDER = 'GET_ORDER';
export const VERIFY_SIGNATURE_FILE = 'VERIFY_SIGNATURE_FILE';

export const SET_FORM = 'SET_FORM';
export const SET_FORM_LOADING = 'SET_FORM_LOADING';
export const SET_FORM_ANSWERS = 'SET_FORM_ANSWERS';
export const SET_FORM_ERRORS = 'SET_FORM_ERRORS';
export const SET_STEPS = 'SET_STEPS';

export const SET_FILES = 'SET_FILES';
export const SET_FILES_LOADING = 'SET_FILES_LOADING';
export const SET_FILES_ERROR = 'SET_FILES_ERROR';

export const SET_ORDER = 'SET_ORDER';
export const SET_ORDER_LOADING = 'SET_ORDER_LOADING';

export const CREATE_ACCESS_KEY = 'CREATE_ACCESS_KEY';
export const DEACTIVATE_ACCESS_KEY = 'DEACTIVATE_ACCESS_KEY';

export const SET_AUTOBILLS_ORDER = 'SET_AUTOBILLS_ORDER';
export const GET_ACCESS_KEYS = 'GET_ACCESS_KEYS';

export const SET_BANK_ACCOUNTS_ORDER = 'SET_BANK_ACCOUNTS_ORDER';
export const SET_BANK_ACCOUNTS_ORDER_LOADING = 'SET_BANK_ACCOUNTS_ORDER_LOADING';

